<template>
    <div v-show="itemList && itemList.length > 0" style="background-color: #fff;">
        <!-- <h1 style="font-size: 30px">
            {{title}}
        </h1> -->
        <header class="nav-box container" v-if="iskr">
            <div class="header d-flex">
                <a href="/" class="nav-item nav-logo mr-auto">
<!--                    <img src="https://pic.compgoo.com/uploads/fbb6f7f34c426320c0f0cf98b576fcd7.jpg?_t=1694313684&_s=1b52e372b9b3d5aec1a8d80167ec655b&_token=8dbc72f8c9253808b8de0e3721651cf1&_e=10&_c=1cdfecc90d95d3251509e6d5b5a15d62" alt="" class="img-fluid">-->
<!--                    <img src="https://d1q4aqp7bomo9e.cloudfront.net/Public/Uploads/audit_tool/87/75/6f2778b91b52709254734834bcdb1f7d.webp" alt="" class="img-fluid">-->
                    <img src="https://d1q4aqp7bomo9e.cloudfront.net/Public/Uploads/audit_tool/96/71/608e8714c746309f3dd8ab74149b6eb6.webp" alt="" class="img-fluid">
                </a>
                <div class="d-flex align-items-center accordion"></div>
            </div>
        </header>
        <div>
            <el-carousel indicator-position="outside" style="width: 100%;" class="swiper">
                  <el-carousel-item v-for="item in bannerList" :key="item" style="height: 100%;width: 100%;">
                    <img :src="`https://d1q4aqp7bomo9e.cloudfront.net${item}`" alt="" style="height: 100%; width: 100%;display: inline;max-width: 100%;">
                  </el-carousel-item>
            </el-carousel>
        </div>
        <!-- 中间的集合页banner -->
<!--        <div class="home-cate d-flex align-items-center flex-wrap my-5">-->
<!--         <div class="thumbnail pr">-->
<!--             <a href="/index/category?category_id=1902680&amp;coll_id=1003935025&amp;">-->
<!--                 <img data-original="https://pic.compgoo.com/uploads/448f2114f600b953f184775debc858dd.jpg?_t=1694313684&amp;_s=ad4296e8a84c2b1d414b9f6a59030793&amp;_token=8dbc72f8c9253808b8de0e3721651cf1&amp;_e=10&amp;_c=4be2e1913eaf4657464c8bac55c30ee5" class="lazy" src="https://pic.compgoo.com/uploads/448f2114f600b953f184775debc858dd.jpg?_t=1694313684&amp;_s=ad4296e8a84c2b1d414b9f6a59030793&amp;_token=8dbc72f8c9253808b8de0e3721651cf1&amp;_e=10&amp;_c=4be2e1913eaf4657464c8bac55c30ee5" style="display: inline;">-->
<!--                 <h2 class="pa d-flex align-items-center justify-content-center">鞋</h2>-->
<!--             </a>-->
<!--         </div>-->
<!--         <div class="thumbnail pr">-->
<!--             <a href="/index/category?category_id=1902681&amp;coll_id=1003935025&amp;">-->
<!--                 <img data-original="https://pic.compgoo.com/uploads/721f8d331bb4d86218934947baf6a61c.jpg?_t=1694313684&amp;_s=0a6c450183ac2aa12bd280615f349fd0&amp;_token=8dbc72f8c9253808b8de0e3721651cf1&amp;_e=10&amp;_c=5bd382cf2bae3b2aea1567652ad4f4cc" class="lazy" src="https://pic.compgoo.com/uploads/721f8d331bb4d86218934947baf6a61c.jpg?_t=1694313684&amp;_s=0a6c450183ac2aa12bd280615f349fd0&amp;_token=8dbc72f8c9253808b8de0e3721651cf1&amp;_e=10&amp;_c=5bd382cf2bae3b2aea1567652ad4f4cc" style="display: inline;">-->
<!--                 <h2 class="pa d-flex align-items-center justify-content-center">包 </h2>-->
<!--             </a>-->
<!--         </div>-->
<!--         <div class="thumbnail pr">-->
<!--             <a href="/index/category?category_id=1902682&amp;coll_id=1003935025&amp;">-->
<!--                 <img data-original="https://pic.compgoo.com/uploads/d9344b737e9475ade3dbc42f4d1b7038.jpg?_t=1694313684&amp;_s=35d61097e2b3d0f0bd8ad1360a39adba&amp;_token=8dbc72f8c9253808b8de0e3721651cf1&amp;_e=10&amp;_c=286ffe9061a988f8ddf639567ddc870c" class="lazy" src="https://pic.compgoo.com/uploads/d9344b737e9475ade3dbc42f4d1b7038.jpg?_t=1694313684&amp;_s=35d61097e2b3d0f0bd8ad1360a39adba&amp;_token=8dbc72f8c9253808b8de0e3721651cf1&amp;_e=10&amp;_c=286ffe9061a988f8ddf639567ddc870c" style="display: inline;">-->
<!--                 <h2 class="pa d-flex align-items-center justify-content-center">衣服</h2>-->
<!--             </a>-->
<!--         </div>-->
<!--        </div>-->
        <!-- 商品卡片集合 -->
        <div class="container">
            <div v-for="itemsPackage in itemList" class="activity">
                    <h2 style="text-align: center;color: #4781D9;background: #fff;border-radius: 10px;margin: 20px 0 0" class="my-3">
                        <svg style="position: relative;top: 2px;margin: 0 10px;" t="1641474809753" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="24" height="24"><path transform="scale(1, -1) translate(0, -1024)" fill="#4781D9" d="M967.72 692.9110000000001c-38.648 37.665-92.305 50.723-151.09 36.839-28.517-6.735-56.659-19.657-83.049-37.665a365.8 365.8 0 0 0 27.516-48.524c21.262 14.571 43.776 24.88 66.539 30.242 8.505 2.062 16.76 3.299 24.764 3.849 31.894 2.062 60.036-7.286 80.798-27.493 25.89-25.292 38.023-65.157 34.146-112.306-4.253-50.448-26.015-102.408-61.411-146.259-35.521-43.988-79.797-74.092-124.824-84.676-7.629-1.787-12.007-2.749-19.261-3.299-9.756-19.932-14.759-40.139-27.641-57.733 11.131-1.512 13.133-0.824 24.89 0a186.73 186.73 0 0 1 32.895 5.087c55.783 13.196 110.065 49.623 152.716 102.684 42.651 52.923 69.041 116.429 74.294 178.974 5.626 65.706-12.635 122.615-51.282 160.28zM773.855 468.711c0 111.206-42.525 211.691-110.691 283.033H166.37C98.204 680.264 55.68 579.9169999999999 55.68 468.711c0-138.561 65.914-260.214 165.223-329.908h387.605c99.432 69.694 165.347 191.348 165.347 329.908z m88.052-423.38H24.285c-8.254 0-15.008 7.423-15.008 16.495v8.248c0 9.072 6.754 16.495 15.008 16.495h837.496c8.255 0 15.008-7.423 15.008-16.495v-8.248c0.126-9.073-6.628-16.495-14.882-16.495z" p-id="2180" ></path></svg>
                        {{itemsPackage.name}}
                    </h2>
                    <div class="row">
                        <div v-for="item in itemsPackage.items_detail" class="col-md-3 col-6 my-2" @click="goDetail(item)" >
                            <div class="card-product" style="font-size: 1rem;height: 100%;">
                                <span style="display: block;border: 1px solid #f2f2f2;height: 100%; outline: none;cursor: pointer;color: #333333;">
                                    <div class="item">
                                        <div class="img">
                                     <img v-lazy="item.cover" alt="" src="" style="display: inline;max-width: 100%;">
                                    </div>
                                   </div>
                                    <div class="content p-3" style="padding: 1rem;">
                                        <div class="name mb-2 text-truncate" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap; margin-bottom: 0.5rem;">
                                            {{item.title}}
                                        </div>
                                        <div class="price flex" style="display: flex;align-items: baseline;">
                                            <span style="margin: 0 5px;">{{item.symbol}}</span>
                                            <span style="font-size: 1.5rem;" class="price-1">{{item.price}}</span>
                                        </div>
                                    </div>
                                </span>

                            </div>
                        </div>
                    </div>
                </div>
        </div>

        <footer class="mt-5" style="margin-top: 3rem;">
            <div class="foot" style="font-size: .87rem;border-top: 10px solid #f9f9f9;">
                <div class="f-art" style="text-align: center;">
                    <div class="d-flex justify-content-center align-items-center flex-wrap my-5 container" style="margin-bottom: 20px;">
                        <div  v-for="item in footer.slice(0,5)" style="margin-left: 50px; margin-bottom: 50px;" class="foot-item">
                    <a :href="item.target" class="attach-link" style="flex: 1;color: #333333;">{{item.text}}</a>
                </div>
                <div class="attach-link-cont foot-item" style="margin-left: 50px;margin-bottom: 50px;" >
                    <a style="flex: 1;" class="attach-link" v-for="item in footer.slice(5,7)" v-if="item.text">{{item.text}}</a>
                </div>
                <div class="attach-link-cont" style="padding-top: 15px">
                    <!--        <p style="width: 6rem">地址：臺灣桃園市蘆竹區南山路二段121之5號</p>-->
                </div>
                    </div>

                </div>
                <div class="copy" style="border-top: 1px solid #e4e4e4;" v-if="iskr">
                <p style="text-align: center; color: #666;">
                    <img src="https://d1q4aqp7bomo9e.cloudfront.net/Public/Uploads/audit_tool/90/75/3db122e1678b91dfa57095d6a5cdf76b.webp" style="width:auto;max-height:50px;">
                </p>
                <!-- <p class="pt-3 text-center" style="color: #666;text-align: center;padding-top: 1rem;">
                    <br>123.
                    <br>456.
                    <br>789,
                    <br>123 13:00-14:30(999)<br>
                </p> -->
               <p class="py-3" style="padding-bottom: 1rem;text-align: center;padding-top: 1rem;">Copyright ©2023 <a href="/" title="www.cheapct.top">www.cheapct.top</a> All rights reserved</p>
    </div>
            </div>
        </footer>


        <!-- <div class="index" v-show="itemList && itemList.length > 0"> -->
            <!-- <div class="content">


                <div v-for="itemsPackage in itemList" >
                    <h1 style="text-align: center;color: #4781D9;background: #fff;border-radius: 10px;margin: 20px 0 0">
                        <svg style="position: relative;top: 2px;margin: 0 10px;" t="1641474809753" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  width="24" height="24"><path transform="scale(1, -1) translate(0, -1024)" fill="#4781D9" d="M967.72 692.9110000000001c-38.648 37.665-92.305 50.723-151.09 36.839-28.517-6.735-56.659-19.657-83.049-37.665a365.8 365.8 0 0 0 27.516-48.524c21.262 14.571 43.776 24.88 66.539 30.242 8.505 2.062 16.76 3.299 24.764 3.849 31.894 2.062 60.036-7.286 80.798-27.493 25.89-25.292 38.023-65.157 34.146-112.306-4.253-50.448-26.015-102.408-61.411-146.259-35.521-43.988-79.797-74.092-124.824-84.676-7.629-1.787-12.007-2.749-19.261-3.299-9.756-19.932-14.759-40.139-27.641-57.733 11.131-1.512 13.133-0.824 24.89 0a186.73 186.73 0 0 1 32.895 5.087c55.783 13.196 110.065 49.623 152.716 102.684 42.651 52.923 69.041 116.429 74.294 178.974 5.626 65.706-12.635 122.615-51.282 160.28zM773.855 468.711c0 111.206-42.525 211.691-110.691 283.033H166.37C98.204 680.264 55.68 579.9169999999999 55.68 468.711c0-138.561 65.914-260.214 165.223-329.908h387.605c99.432 69.694 165.347 191.348 165.347 329.908z m88.052-423.38H24.285c-8.254 0-15.008 7.423-15.008 16.495v8.248c0 9.072 6.754 16.495 15.008 16.495h837.496c8.255 0 15.008-7.423 15.008-16.495v-8.248c0.126-9.073-6.628-16.495-14.882-16.495z" p-id="2180" ></path></svg>
                        {{itemsPackage.name}}
                    </h1>
                    <div class="item-list">
                        <div v-for="item in itemsPackage.items_detail" class="item-info" @click="goDetail(item)" style="height: 343px; width: 255px;padding: 0px;border: 1px solid #f2f2f2;cursor: pointer;">
                            <div class="img-box">
                                <img v-lazy="item.cover" alt="" src="" style="height: 253px;width: 253px;">
                            </div>
                            <div style="height: 90px;">
                            <p class="title" >{{item.title}}</p>
                            <p class="price">
                                <span class="symbol">{{item.symbol}}</span>
                                <span class="num">{{item.price}}</span>
                            </p>

                            </div>

                        </div>
                    </div>
                </div>

            </div> -->
            <!--attach start-->
            <!-- <div class="attach-cont" v-if="footer && footer.length > 0"> -->
                <!--            <div class="attach-link-cont">-->
                <!--                <a v-for="item in footer.slice(0,4)" :href="item.target" class="attach-link">{{item.text}}</a>-->
                <!--            </div>-->
                <!-- <div class="attach-link-cont mt30" v-for="item in footer.slice(0,5)">
                    <a :href="item.target" class="attach-link" style="padding-top: 10px">{{item.text}}</a>
                </div>
                <div class="attach-link-cont" style="padding-top: 15px">
                    <a style="padding: 0 20px; border: none" class="attach-link" v-for="item in footer.slice(5,7)">{{item.text}}</a>
                </div> -->
                <!-- <div class="attach-link-cont" style="padding-top: 15px"> -->
                    <!--        <p style="width: 6rem">地址：臺灣桃園市蘆竹區南山路二段121之5號</p>-->
                <!-- </div> -->
            <!-- </div> -->
        <!-- </div> -->
    </div>

</template>

<script>
import {getConfigInfo, getHomeItem, promotion} from "../api/permission";
import config from '../util/config.js';
  export default {
    data() {
      return {
        itemList: [],
        id: '',
        path: '',
        host: location.host,
        banner: '',
        title: '',
        footer: [],
        bannerList: [],
        iskr: false,
      }
    },
    created() {
      this.getHomeItem();
      // let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/', 'https://www.cheapct.top/'];
      let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/'];

      if (krips.includes(location.origin + '/')) {
          this.iskr = true;
      }
    },
    methods: {
      getHomeItem() {
        // 获取configId和ConfigName
        let hostname = window.location.hostname;
        // 本地测试时使用
        if (hostname === 'localhost'){
          hostname = 'www.cheapct.top'
          // hostname = 'www.pokersh.top'
        }
        getConfigInfo({domain: hostname}).then(res => {
          if (res.data && res.data.data && res.data.data.modules){
            this.itemList = res.data.data.modules;
            this.footer = res.data.data.footer;
            this.bannerList = res.data.data.banner;
            // this.banner = `https://d1q4aqp7bomo9e.cloudfront.net${bannerList[Math.floor(bannerList.length * Math.random())]}`;
            this.title = res.data.data.title
            document.title = `${this.title}Mall|Homeware este aici`;
            // 渲染seo
            let seo = JSON.parse(res.data.data.seo)
            document.querySelector('meta[name="keywords"]').setAttribute('content',seo.description);
            document.querySelector('meta[name="description"]').setAttribute('content', seo.keywords);
          }else{
            getHomeItem({}).then(res => {
              if (res.data && res.data.data && res.data.data.modules) {
                this.itemList = res.data.data.modules;
                this.footer = res.data.data.footer;
                const bannerList = res.data.data.banner;
                this.banner = `https://d1q4aqp7bomo9e.cloudfront.net${bannerList[Math.floor(bannerList.length * Math.random())]}`;
                this.title = res.data.data.title
                document.title = `${this.title}Mall|Homeware este aici`;
                // 渲染seo
                let seo = JSON.parse(res.data.data.seo)
                document.querySelector('meta[name="keywords"]').setAttribute('content',seo.Description);
                document.querySelector('meta[name="description"]').setAttribute('content', seo.Keywords);
              } else {
                location.href = "./static/home.html";
              }
            }).catch(() => {
              location.href = "./static/home.html";
            })
          }
        }).catch(() => {
          location.href = "./static/home.html";
        })

        // 发送cartsee埋点数据
        let count = 0;
        let uuid = this.generateUUID()
        this.cartseePost(count,uuid)
      },
      goDetail(item) {
        location.href = `/detail?id=${item.product_hash}&cl=${item.cl}&home=${location.pathname}&path=${this.$route.query.path || ''}`
      },
      cartseePost(count,uuid){
        if (count < 10) {
          // 条件满足时的处理逻辑
          if (window.cartq){
            count = 10
            window.cartq('track', 'Site/Visit', {
              "pathName": window.location.href, // 当前页面地址 location.href
              "email": "", // 用户的email,在已登录情形下才会有
              "phone": "" // 用户的phone,在已登录情形下才会有
            }, {
              "uid": uuid,//第三方的唯一用户标识, 类似cookie
              "customerId": "" //用户id，在已登录情形下才会有 ，
            })
          }
          count++;
          setTimeout(() => {
            this.cartseePost(count,uuid)
          }, 2000); // 2秒钟后再次执行循环器
        }
      },
      generateUUID(){
        // 1. 判断cookie是否有唯一uuid：cartsee_uuid
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          if (cookie.startsWith('cartsee_uuid=')) {
            return cookie.substring('cartsee_uuid='.length)
          }
        }

        // 2. 新建uuid存入cookie
        let cartsee_uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0,
              v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        })
        document.cookie = ('cartsee_uuid=' + cartsee_uuid);
        return cartsee_uuid;
      }
    }
  }
</script>

<style scoped>
/* header的css */
.nav-box {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (min-width: 1200px) {
        max-width: 1140px;
    }
    .header {
        padding: 0.5rem 0;
        display: flex;
    }
}

.nav-logo {
    width: 100px;
    display: flex;
    align-items: center;
}

@media screen and (min-width: 920px)  {
    .nav-logo {
        width: 200px;
    }
}
.img-fluid {
    max-width: 100%;
    height: auto;
}
.swiper /deep/ .el-carousel__indicators--outside{
    display: none;

}

/* 轮播图的css */
@media screen and (max-width: 576px) {
    .swiper {
        height: 211px !important;
    }
}
@media screen and (max-width: 576px) {
    .swiper /deep/ .el-carousel__container {
        height: 92% !important;
    }
}

@media screen and (min-width: 992px) {
    .swiper {
        height: 650px !important;
        padding: 2rem 5rem !important;
    }
}
@media screen and (min-width: 992px) {
    .swiper /deep/  .el-carousel__container{

        height: 98% !important;
    }
}

@media screen and (min-width: 992px) {
    .swiper{
        overflow: hidden;
    }
}


/* 集合页banner collection的样式 */

.align-items-center {
    align-items: center !important;
}
.flex-wrap {
    flex-wrap: wrap !important;
}
.d-flex {
    display: flex !important;
}
.home-cate, .thumbnail {
    flex: 1;
}
.thumbnail {
    overflow: hidden;
}
.pr {
    position: relative;
}

.pr a {
    cursor: pointer;
    color: #333333;
    text-decoration: none;
    outline: none;
}
.pr a img {
    display: inline;
    transform: scale(1);
    transition: .5s;
    max-width: 100%;
}

.thumbnail h2 {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 1.5rem;
    background-color: rgb(0,0,0,0.3);
    color: #fff;
    padding: 0.5rem;
    transition: .5s;
}
.pa {
    position: absolute;
}

.justify-content-center {
    justify-content: center !important;
}
.d-flex {
    display: flex !important;
}
.flex-wrap {
    flex-wrap: wrap !important;
}
.align-items-center {
    align-items: center !important;
}
.my-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
}

/* 商品卡片的样式 */
@media screen and (min-width: 576px) {
    .container {
        max-width: 540px;
    }
}
@media screen and (min-width: 768px) {
    .container {
        max-width: 720px;
    }
}
@media screen and (min-width: 992px) {
    .container {
        max-width: 960px;
    }
}
@media screen and (min-width: 576px) {
    .container {
        max-width: 540px;
    }
}



@media screen and (min-width: 992px) {
    .container {
        max-width: 960px;
    }
}

@media screen and (min-width: 768px) {
    .container {
        max-width: 720px;
    }
}

@media screen and (min-width: 1200px) {
    .container {
        max-width: 1140px;
    }
}

@media screen and (min-width: 1200px) {
    .container {
        max-width: 1140px;
    }
}

@media screen and (max-width: 576px) {
    .my-3 {
        font-size: 1rem !important;
    }
}
/* 商品图片始终为等比例正方形 */
.card-product {
    font-size: 1rem;
}
.card-product .item {
    position: relative;
    width: 100%;
    padding-bottom: 100%;
}
.card-product .img {
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
}
.card-product img {
    width: 100%;
    height: 100%;
}

.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
}

.my-2 {
    margin-top: 0.2rem !important;
    margin-bottom: 0.2rem !important;
}
.col-6 {
    flex: 0 0 50%;
    max-width: 50%;
}
@media screen and (min-width: 768px) {
    .col-md-3 {
        flex: 0 0 25%;
        max-width: 25%;
    }
}
.col, .col-1, .col-10, .col-11, .col-12, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-auto, .col-lg, .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-auto, .col-md, .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-auto, .col-sm, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-auto, .col-xl, .col-xl-1, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-auto {
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
}



.container {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    margin-left: auto;
    margin-right: auto;
}

    .index {
        margin: 0 auto;
        /* max-width: 1200px; */
        min-height: 100%;
        background: #fff;
    }
    .index .content {
        padding: 0 20px 20px;
    }

    .index h1 {
        padding-right: 20px;
    }

    h1 .img-left {
        float: left;
        width: 24px;
        cursor: pointer;
        background: #fff;
    }

    h1 {
        padding: 10px;
        text-align: center;
        font-size: 18px;
        font-weight: normal;
        background: #fff;
    }

    .banner {
        overflow: hidden;
        /*border-radius: 20px;*/
    }

    .banner img {
        width: 100%;
        height: 80%;
    }

    .item-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0;
    }

    .item-list .item-info {
        margin-top: 15px;
        padding: 15px;
        width: 49%;
        border-radius: 10px;
        background: #fff;
        font-size: 12px;
        cursor: pointer;
    }

    .item-info .img-box {
        display: flex;
        margin: 0 auto;
        overflow: hidden;
        height: calc(47vw - 38px);
        max-height: 261px;
        align-items: center;
    }

    .item-info .img-box img {
        width: 100%;
    }

    .item-info .title {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 10px;
        color: #666;
    }

    .item-info .price {
        margin-top: 5px;
        /* color: #e12020; */
    }

    .attach-cont .attach-link-cont {
        display: flex;
        justify-content: center;
        text-align: center;
        color: #666;
    }
    .attach-cont .attach-link-cont .attach-link {
        padding: 0 20px;
        border-left: 2px solid #666
    }
    .attach-cont .attach-link-cont .attach-link:first-child {
        border-left: none
    }

    @media screen and (max-width: 400px) {
        .attach-cont .attach-link-cont .attach-link {
            font-size:12px;
            padding: 0 5px;
        }
        .index .content {
            padding: 0 5px 5px;
        }
    }
    @media screen and (min-width: 250px) and (max-width: 600px)  {
        .attach-cont .attach-link-cont .attach-link {
            font-size:14px;
            padding: 0 10px;
        }
        .index .content {
            padding: 0 10px 10px;
        }
        .col-md-3 {
            padding: 0.2rem !important;
        }
        .my-2 {
            margin-top: 0.01rem !important;
            margin-bottom: 0.01rem !important;
        }
        .my-3 {
            margin: 0.2rem !important;
        }
        .mb-2 {
            /* font-size: 0.8rem !important; */
            color: #666 !important;
            font-size: 12px !important;
            display: -webkit-box !important;
            -webkit-line-clamp: 2 !important;
            -webkit-box-orient: vertical !important;
            font-family: sans-serif !important;
            text-overflow: -o-ellipsis-lastline !important;
            white-space: normal !important;
        }
        .price {
            font-size: 0.8rem !important;
        }
        .price-1 {
            font-size: 12px !important;
            font-family: '\\5FAE\8F6F\96C5\9ED1',sans-serif !important;
        }
        .mt-5 {
            margin-top: 1rem !important;
        }
        .foot-item {
            margin-left: 0px !important;
            margin-bottom: 0px !important;
            flex: 0 0 100%;
            margin-bottom: 1rem !important;
        }
        .my-5 {
            margin-top: 1rem !important;
            margin-bottom: 0 !important;
        }
        .price {
            color: rgb(225, 32, 32) !important;
            font-size: 12px !important;
        }
    }
    .price {
            color: #e12020 !important;
        }
    .mb-2 {
        color: #666 !important;
        display: -webkit-box !important;
        -webkit-line-clamp: 2 !important;
        -webkit-box-orient: vertical !important;
        font-family: sans-serif !important;
        text-overflow: -o-ellipsis-lastline !important;
        white-space: normal !important;

    }
    @media screen and (min-width: 600px) and (max-width: 800px) {
        .item-list .item-info,
        .attach-cont .attach-link-cont .attach-link {
            font-size:15px;
        }
    }
    @media screen and (min-width: 800px) {
        .item-list .item-info,
        .attach-cont .attach-link-cont .attach-link {
            font-size:16px;
        }
    }
    /* .my-3 {
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    } */
    .activity h2 {
        font-size: 2rem;
        text-align: center;
    }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/views/Index.vue